import React from "react";
import PropTypes from "prop-types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const humanSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const SortableDocument = (props) => {
  const { document, onRename, onDelete } = props;

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: document.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="bg-gray-50 p-4 mb-3 flex justify-between items-center gap-4"
    >
      <span className="text-lg cursor-move text-gray-400" {...attributes} {...listeners}>
        ≡
      </span>
      <div className="min-w-0 flex-1">
        <input
          className="w-full bg-transparent font-medium focus:bg-white focus:px-2 focus:py-1"
          defaultValue={document.title}
          onBlur={(e) => onRename(document, e.target.value)}
        />
        <div className="text-xs text-gray-500 truncate">
          {document.filename} · {humanSize(document.byte_size)} ·{" "}
          {document.created_at}
        </div>
      </div>
      <div className="flex items-center gap-4 shrink-0">
        <a
          href={document.download_url}
          className="text-sm text-gray-600 hover:text-black"
        >
          Pobierz
        </a>
        <button
          className="flex items-center gap-1 text-yellow-800 hover:text-yellow-900"
          onClick={() => onDelete(document)}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3H5m14 0H5"
            />
          </svg>
          Usuń
        </button>
      </div>
    </div>
  );
};

SortableDocument.propTypes = {
  document: PropTypes.object,
  onRename: PropTypes.func,
  onDelete: PropTypes.func,
};

export default SortableDocument;
